import React from "react"
import cx from "classnames"
import { Menu as MenuPrimitive } from "@base-ui/react/menu"
import { VisuallyHidden } from "../visually-hidden"

export type MenuTriggerProps = {
  /** Accessible label for icon-only triggers with no visible text */
  accessibleName?: string
  /** The trigger element content */
  children?: React.ReactNode
  /** Whether the trigger is disabled */
  disabled?: boolean
  /** Replace the default button with your own element */
  render?: React.ReactElement
}

const triggerStyles = [
  "rounded-md inline-flex items-center gap-1.5",
  "outline outline-2 outline-offset-2 outline-transparent focus-visible:outline-gray-900",
  "cursor-pointer",
  "transition-colors"
]

export function MenuTrigger({
  accessibleName,
  children,
  disabled,
  render
}: MenuTriggerProps) {
  return (
    <MenuPrimitive.Trigger
      className={cx(triggerStyles)}
      disabled={disabled}
      render={render}
      data-slot="menu-trigger"
    >
      {accessibleName && <VisuallyHidden>{accessibleName}</VisuallyHidden>}
      {children}
    </MenuPrimitive.Trigger>
  )
}

MenuTrigger.displayName = "Menu.Trigger"
